import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  HostBinding
} from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { slideToRight } from '../../shared/animations.collections';
import { CreateEventService } from '../../nav/shared/createevent.listener';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StateModel } from '../../models/account-ledger.model';
import { ShoppingCartService } from '../../services/shopping-cart.service';

@Component({
  selector: 'app-digital-wallet',
  templateUrl: './digital-wallet.component.html',
  styleUrls: ['./digital-wallet.component.css'],
  animations: [slideToRight('100%')]
})
export class DigitalWalletComponent implements OnInit {

  @HostBinding('@slideToRight') ani;

  userInfoGroup: FormGroup;
  stateList: string[];

  constructor(
    private pageService: CreateEventService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private shoppingCartService: ShoppingCartService
  ) { }

  ngOnInit() {

    this.shoppingCartService.getState().subscribe((res: StateModel) => {
      this.stateList = res.states;
    },
      (error: any) => {
        console.info(error);
      });

  }

  changeState(event): void {

  }

  closePage() {
    console.log('destory this comp');
    this.pageService.destoryComponent('person');
  }

}
